
<div id="container">
    <img *ngFor="let url of imageList" src="{{url}}" class="preuveImage">
</div>
